export default __webpack_public_path__ + "static/media/PuntoVerdeVacio.58c2d27e.png";